module.exports = require('./dist/echarts-amap.min.js')



//////////////////
// WEBPACK FOOTER
// ./~/echarts-amap/index.js
// module id = 377
// module chunks = 13